import { __decorate } from "tslib";
import { Options as Component, Prop, mixins } from 'vue-property-decorator';
import FormGeneratorField from './FormGeneratorField.mjs';
let FormGeneratorIconizedField = class FormGeneratorIconizedField extends mixins(FormGeneratorField) {
    mdIcon;
    customIcon;
    icon;
    iconSize;
    svgIcon;
    fillRule;
};
__decorate([
    Prop()
], FormGeneratorIconizedField.prototype, "mdIcon", void 0);
__decorate([
    Prop()
], FormGeneratorIconizedField.prototype, "customIcon", void 0);
__decorate([
    Prop()
], FormGeneratorIconizedField.prototype, "icon", void 0);
__decorate([
    Prop()
], FormGeneratorIconizedField.prototype, "iconSize", void 0);
__decorate([
    Prop()
], FormGeneratorIconizedField.prototype, "svgIcon", void 0);
__decorate([
    Prop()
], FormGeneratorIconizedField.prototype, "fillRule", void 0);
FormGeneratorIconizedField = __decorate([
    Component({})
], FormGeneratorIconizedField);
export default FormGeneratorIconizedField;
//# sourceMappingURL=FormGeneratorIconizedField.mjs.map